import React from "react";
import { DatePicker as AntDatePicker } from "antd";
import locale from "antd/es/date-picker/locale/tr_TR";

export default function DatePicker({
  isRangePicker = false,
  readOnly = false,
  ...props
}) {
  return isRangePicker ? (
    <AntDatePicker.RangePicker
      {...props}
      className={readOnly ? "readOnly" : undefined}
      locale={locale}
    />
  ) : (
    <AntDatePicker
      {...props}
      className={readOnly ? "readOnly" : undefined}
      locale={locale}
    />
  );
}
